var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('client-only',[_c('div',{staticClass:"resultsLoader text-center"},[_c('img',{attrs:{"src":require("../../static/loader.png"),"alt":"טעינה"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }